/**
 * User mapping management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class UserMappingManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async uploadMapping(file: File | Blob, params?: Record<string, any>): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post('/api/cdp/users/extend/upload', { data: formData, params, headers: {} });
  }

  async downloadTemplate(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/users/extend/downloadTemplate', {
      params,
      responseType: 'blob',
    });
  }

  async listMappings(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/system/sys_user_mapping/page', {
      params: { current: page, size, ...params },
    });
  }

  async getBySlaveUserId(slaveUserId: string): Promise<Record<string, any>> {
    return this.session.get(`/api/system/sys_user_mapping/getBySlaveUserId/${slaveUserId}`);
  }
}
